import { Button, Grid, Hidden } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import ScrollSpy from 'react-scrollspy-navigation';
import { heroTimeLineObj } from 'assets/animation/portalAnimation';
import { useSelector } from 'react-redux';
import { IApplicationState } from 'store/state/app-state';

const Home: React.FC = () => {
    const setting = useSelector((state: IApplicationState) => state?.Setting);
    const heroTimeLine = React.useRef(null);

    React.useEffect(() => {
        heroTimeLineObj(heroTimeLine);
    }, []);

    const handleClinicianLoginClick = () => {
        window.open(setting?.cliniciaN_PORTAL_APPLICATION_URL, '_blank');
    };

    const handlePatientLoginClick = () => {
        window.open(setting?.patienT_PORTAL_APPLICATION_URL, '_blank');
    };

    return (
        <section className="hero" ref={heroTimeLine} id="home">
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                        <div className="hero-content">
                            <h2>
                                Reach better health Reach <strong>better life</strong>
                            </h2>
                            <h6>
                                We provide solutions for mental health practitioners to deliver high quality healthcare
                                to patients using our platform
                            </h6>
                            <ScrollSpy offsetTop={80} duration={1500}>
                                <Hidden lgUp lgDown>
                                    <a href="#about-us" ref={React.createRef()} title="About Us" className="nav-link">
                                        About Us
                                    </a>
                                </Hidden>
                                <a href="#practice-with-us" ref={React.createRef()} className="find-link">
                                    <img src={images.arrowForward} alt="Arrow" />
                                    Find out how Healthreach can work for you
                                </a>
                            </ScrollSpy>

                            <div className="btn-groups">
                                <Button
                                    variant="outlined"
                                    title="Join as Clinician"
                                    onClick={handleClinicianLoginClick}
                                >
                                    Join as Clinician
                                    <img src={images.btnArrowIcon} alt="Arrow" />
                                </Button>
                                <Button variant="outlined" title="Access As Patient" onClick={handlePatientLoginClick}>
                                    Access As Patient
                                    <img src={images.btnArrowIcon} alt="Arrow" />
                                </Button>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <div className="hero-mockup">
                            <div className="circle-outer-layer"></div>
                            <div className="circle-layer"></div>
                            <div className="hero-mockup-inner">
                                <img src={images.heroFrame} alt="Frame" className="hero-frame" />
                                <div className="frame-block online">
                                    <div className="svg-wrap">
                                        <img src={images.heroOnlineIcon} alt="Icon" />
                                    </div>
                                    <div>
                                        <strong>Online Consultation</strong>
                                        <span>using one platform</span>
                                    </div>
                                </div>
                                <div className="frame-block fear">
                                    <div className="svg-wrap">
                                        <img src={images.heroFearIcon} alt="Icon" />
                                    </div>
                                    <div>
                                        <strong>High Quality</strong>
                                        <span>health care</span>
                                    </div>
                                </div>
                                <div className="frame-block bill">
                                    <div className="svg-wrap">
                                        <img src={images.heroBillIcon} alt="Icon" />
                                    </div>
                                    <div>
                                        <strong>Flexible Billing</strong>
                                        <span>both bulk and gap billing</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default Home;
